<template>
  <router-link
    :to="makeRedirectLink()"
    class="category-item">
    <div>
      <picture-component
        :src="imgObj.src"
      />
      <premium-indicator
        v-show="itemInfo.is_exclusive"
        size="large"/>
    </div>
    <!-- <div
      v-show="itemInfo.is_exclusive"
      class="premium-wrapper"
    >
      <premium-indicator size="large"/>
    </div> -->
    <p
      v-show="itemInfo.title"
      class="main-title">{{ itemInfo.title }}</p>
  </router-link>
</template>
<script>
import ErrorPlaceholder from '../assets/images/placeholder.png';
import Event from '../services/PlayerEvent';

export default {
  name: 'CategoryItem',
  components: {
    'premium-indicator': () => import(/* webpackChunkName: "category-item" */ './PremiumIndicator'),
  },
  props: {
    itemInfo: {
      type: Object,
      default: () => {},
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ErrorPlaceholder,
      imgObj: {
        src: this.itemInfo.display_image_url,
        error: ErrorPlaceholder,
      },
      eventProvider: new Event(),
    };
  },
  methods: {
    triggerSegmentEvent() {
      const bucketData = { ...this.bucket };
      bucketData.items = {};
      const bucketItemData = { ...this.itemInfo };
      bucketItemData.item_position = this.$vnode.key;
      this.eventProvider.triggerContentSelectEvent(bucketData, bucketItemData);
    },
    makeRedirectLink() {
      return `/listen/${this.itemInfo.publisher.slug}/${this.itemInfo.slug}/${this.itemInfo.uuid}`;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/mixins.scss", "../assets/scss/variables.scss";
.category-item {
  max-width: 206px;
  // max-height: 206px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 32px !important;
  position: relative;
  display: block;
  img {
    background: #dedede;
    // margin-bottom: 8px;
    &[lazy=loading] {
      background: #eee;
    }
  }
  .premium-wrapper {
    margin-bottom: 16px;
  }
  .main-title {
    color: #ffffff;
    @include multilinetruncate(14px, 18px, 2);
    margin-top: 24px;
  }
  > div {
    position: relative;
  }
}
@media (max-width: $xs) {
  .category-item {
    margin-bottom: 0 !important;
    .main-title {
      @include multilinetruncate(13px, 18px, 2);
    }
  }
}
</style>
